// extracted by mini-css-extract-plugin
module.exports = {"root":"RegionButtonGroup_root__2n14h","button":"RegionButtonGroup_button__32QTD","active":"RegionButtonGroup_active__2rj0y"};